import { Elm } from './Main.elm';

Elm.Main.init({
  node: document.getElementById('myapp'),
  flags: 0  
});